import script from "./TelegramHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramHeader.vue?vue&type=script&setup=true&lang=js"

import "./TelegramHeader.vue?vue&type=style&index=0&id=c2856c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2856c7a"]])

export default __exports__